module.exports = __webpack_public_path__ + "static/img/dashboard.adf027c8.svg";